/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { IImprimirFolha } from '../../../shared/services/api/rh/folha/FolhaService';


async function ImpressaoFolha(dados: IImprimirFolha[], periodo: string) {

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const Tinss = dados.reduce((acc, item) => acc + item.inss, 0);
  const THE = dados.reduce((acc, item) => acc + item.vhoraextra, 0);
  const TBC = dados.reduce((acc, item) => acc + item.vbomba, 0);
  const TDom = dados.reduce((acc, item) => acc + item.vdomingo, 0);
  const TPI = dados.reduce((acc, item) => acc + item.vpistola, 0);
  const TFamilia = dados.reduce((acc, item) => acc + item.salariofamilia, 0);
  const TGarti = dados.reduce((acc, item) => acc + item.gratificacao, 0);
  const TFalta = dados.reduce((acc, item) => acc + item.vfalta, 0);
  const TVale = dados.reduce((acc, item) => acc + item.vale, 0);
  const TOutrosAl = dados.reduce((acc, item) => acc + item.alimentacao, 0);
  const Tboni = dados.reduce((acc, item) => acc + item.vinsalubridade, 0);
  const TEvFixoV = dados.reduce((acc, item) => acc + item.eventosfixov, 0);
  const TEvFixoD = dados.reduce((acc, item) => acc + item.eventosfixosd, 0);
  const TVeFixoV = dados.reduce((acc, item) => acc + item.verbasfixasv, 0);
  const TVeFixoD = dados.reduce((acc, item) => acc + item.verbasfixasd, 0);
  const TVeExpV = dados.reduce((acc, item) => acc + item.verbasexpv, 0);
  const TEvExpV = dados.reduce((acc, item) => acc + item.eventosexpv, 0);
  const TEvExpD = dados.reduce((acc, item) => acc + item.eventosexpd, 0);
  const Ttotal = dados.reduce((acc, item) => acc + item.total, 0);

  const rows = dados.map((row) => {
    return [
      {
        table: {
          widths: [226, 239, 105, 27, 34, 25, 30, 35],
          body: [ 
            [
              { text: 'Colaborador: ' + row.nome, fillColor: '#dddddd', alignment: 'left', fontSize: 7, border: [true, true, false, false] },
              { text: 'Função: ' + row.funcao, fillColor: '#dddddd', alignment: 'left', fontSize: 7, border: [false, true, false, false] },
              { text: 'fazenda: ' + row.fazenda, fillColor: '#dddddd', alignment: 'left', fontSize: 7, border: [false, true, false, false] },
              { text: 'salarios:', fillColor: '#dddddd', alignment: 'right', border: [false, true, false, false], fontSize: 7 },
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.salario),
                border: [false, true, false, false], fillColor: '#dddddd', alignment: 'left', fontSize: 7
              },
              { text: 'carteira', border: [false, true, false, false], fillColor: '#dddddd', alignment: 'right', fontSize: 7 },
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.carteira),
                border: [false, true, true, true], fillColor: '#dddddd', alignment: 'left', fontSize: 7
              },
              { text: 'Liquido', border: [true, true, true, true], fillColor: '#dddddd', alignment: 'right', fontSize: 7 },
            ],
            [
              {
                table: {
                  widths: [442, 140],
                  heights: [3],
                  body: [
                    [
                      {
                        table: {
                          widths: [7, 27, 13, 23, 7, 20, 7, 20, 7, 20, 20, 25, 7, 20, 22, 25, 28],
                          body: [
                            [
                              { text: 'S. Contratual', colSpan: 2, alignment: 'center', fontSize: 6 },
                              {},
                              { text: 'H. Extra ', colSpan: 2, alignment: 'center', fontSize: 6 },
                              {},
                              { text: 'B. Costal', colSpan: 2, alignment: 'center', fontSize: 6 },
                              {},
                              { text: 'Pistola', colSpan: 2, alignment: 'center', fontSize: 6 },
                              {},
                              { text: 'Domingo', colSpan: 2, alignment: 'center', fontSize: 6 },
                              {},
                              { text: 'Familia', alignment: 'center', fontSize: 6 },
                              { text: 'Grati.', alignment: 'center', fontSize: 6 },
                              { text: 'G. Função', colSpan: 2, alignment: 'center', fontSize: 6 },
                              {},
                              { text: 'Peri.', alignment: 'center', fontSize: 6 },
                              { text: 'Produ.', alignment: 'center', fontSize: 6 },
                              { text: 'V. Total', fillColor: '#dddddd', alignment: 'center', fontSize: 6 },
                            ],
                            [
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(row.qsalario), alignment: 'center', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vsalario), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(row.horaextra), alignment: 'center', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vhoraextra), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0 }).format(row.bomba), alignment: 'center', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vbomba), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0 }).format(row.pistola), alignment: 'center', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vpistola), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0 }).format(row.domingo), alignment: 'center', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vdomingo), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.salariofamilia), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.gratificacao), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(row.percentualinslubridade), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vinsalubridade), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.periculosidade), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.produtividade), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vencimentos), fillColor: '#dddddd', alignment: 'right', fontSize: 6 },
                            ],
                          ]
                        }, margin: [-5, -3, 0, 0], border: [false, false, false, false],
                      },
                      {
                        table: {
                          widths: [9, 20, 9, 20, 20, 23, 23, 23, 28, 33],
                          body: [
                            [
                              { text: 'Falta', colSpan: 2, alignment: 'center', fontSize: 6 },
                              {},
                              { text: 'DSR', colSpan: 2, alignment: 'center', fontSize: 6 },
                              {},
                              { text: 'inss', alignment: 'center', fontSize: 6 },
                              { text: 'Adianta.', alignment: 'center', fontSize: 6 },
                              { text: 'Consigi.', alignment: 'center', fontSize: 6 },
                              { text: 'Sindical', alignment: 'center', fontSize: 6 },
                              { text: 'Outro AL', alignment: 'center', fontSize: 6 },
                              { text: 'V. Desconto', fillColor: '#dddddd', alignment: 'center', fontSize: 6 },
                            ],
                            [
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(row.falta), alignment: 'center', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(row.vfalta), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(row.dsr), alignment: 'center', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vdsr), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.inss), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.vale), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.consiginado), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.sindical), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.alimentacao), alignment: 'right', fontSize: 6 },
                              { text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.descontos), fillColor: '#dddddd', alignment: 'right', fontSize: 6 },
                            ],
                          ]
                        }, margin: [-5, -3, 0, 0], border: [false, false, false, false],
                      },
                    ]
                  ]
                }, colSpan: 7, margin: [-5, -3, 0, 0], border: [false, false, false, false],
              },
              {},
              {},
              {},
              {},
              {},
              {},
              {
                text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.total),
                border: [false, false, true, false], margin: [0, 6, 0, 0], alignment: 'right', fontSize: 7
              },
            ],
          ]
        }, margin: [0, -7, 0, 0], border: [false, false, false, false],
      },
    ];
  });

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl = process.env.REACT_APP_URL_IMGLOG || '';
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 22, 10, 40],
    pageOrientation: 'landscape',
    header: {
      columns: [
        { text: 'Sif - Sistema Integrado de Fazendas', alignment: 'right', color: 'gray',  fontSize: 6,  margin: [0, 10, 30, 0], }
      ]
    },   
    footer: function (currentPage: number, pageCount: number) {
      return {
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: 'right',
        fontSize: 6,
        color: 'gray',
        margin: [0, 0, 30, 0],
      };
    },
    content: ([
      {
        table: {
          widths: [48, 760],
          body: [
            [
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: [720],
                  body: [
                    [
                      { text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16, margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF', alignment: 'center', fillColor: '#00A47B', border: [false, false, false, false] },
                    ],
                    [
                      { text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true] },
                    ],
                  ]
                }
              },

            ],
            [
              { text: 'Relatório de Folha de Pagamento do Período de ' + periodo, colSpan: 2, margin: [5, 0, 10, 5], fontSize: 18, bold: true, alignment: 'center', border: [false, false, false, false] },
              {}
            ]

          ]
        }
      },
      ...rows,
      { text: 'Valores Totais', style: 'subheader', fillColor: '#dddddd', margin: [8, 3, 10, 2] },
      {
        table: {
          widths: [45, 40, 30, 30, 30, 30, 45, 45, 45, 45, 45, 45, 45, 45, 45, 60],
          body: [
            [
              { text: 'H. E \n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(THE), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'B. C \n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TBC), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'Dom.\n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TDom), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'PI \n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TPI), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'Familia\n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TFamilia), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'Grati.\n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TGarti), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'Bonifi.\n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Tboni), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'inss \n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Tinss), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'Falta\n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TFalta), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'Vale\n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TVale), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              { text: 'Outro Al\n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TOutrosAl), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
              {
                text: 'Ev. Fixo\nV:' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TEvFixoV) + '\n D ' +
                  new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TEvFixoD), alignment: 'center', fillColor: '#dddddd', fontSize: 6
              },
              {
                text: 'Ev. Exp\nV:' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TEvExpV) + '\n D ' +
                  new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TEvExpD), alignment: 'center', fillColor: '#dddddd', fontSize: 6
              },
              {
                text: 'Ve. Fixo\nV:' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TVeFixoV) + '\n D ' +
                  new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TVeFixoD), alignment: 'center', fillColor: '#dddddd', fontSize: 6
              },
              {
                text: 'Ve. Exp\nV:' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(TVeExpV) + '\n D ' +
                  new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2 }).format(TEvExpD), alignment: 'center', fillColor: '#dddddd', fontSize: 6
              },
              { text: 'total \n' + new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Ttotal), alignment: 'center', fillColor: '#dddddd', fontSize: 6 },
            ],
          ]
        },
      },
    ]),

  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();

}
export default ImpressaoFolha;


